// Cargos/posições conhecidos do sistema.
// Espelha os valores usados em LayoutNavigation.vue (SDR, outbound, adm, master).
export const POSITIONS = {
  SDR: "SDR",
  OUTBOUND: "outbound",
  ADM: "adm",
  MASTER: "master",
};

// Quando não há posição definida, o afiliado é tratado como SDR
// (mesma regra do LayoutNavigation.vue).
const normalize = (position) => (position || POSITIONS.SDR).toString().toLowerCase();

const isSDR = (position) => normalize(position) === "sdr";
const isOutbound = (position) => normalize(position) === "outbound";

// Predicados de permissão por rota, derivados das regras de exibição
// dos itens do menu em LayoutNavigation.vue.
export const permissions = {
  // Clientes: todos, exceto SDR e outbound.
  users: (position) => !isSDR(position) && !isOutbound(position),
  // Contratação: todos, exceto SDR.
  hiring: (position) => !isSDR(position),
  // Leads: todos, exceto outbound.
  leads: (position) => !isOutbound(position),
  // Simulador: todos, exceto outbound.
  simulador: (position) => !isOutbound(position),
  // Dashboard: todos, exceto SDR e outbound.
  dashboard: (position) => !isSDR(position) && !isOutbound(position),
  // Resumo: bloqueado para outbound (deve permanecer apenas em Contratação).
  home: (position) => !isOutbound(position),
  // Gestão: bloqueado para outbound (deve permanecer apenas em Contratação).
  management: (position) => !isOutbound(position),
};

// Rota segura de fallback quando o acesso é negado, conforme o cargo.
// - SDR não acessa Clientes/Dashboard, mas acessa Leads.
// - outbound só acessa Contratação.
// - adm/master acessam tudo.
export const defaultRouteFor = (position) => {
  if (isOutbound(position)) return "hiring";
  if (isSDR(position)) return "leads";
  return "users";
};
